module.exports = __webpack_public_path__ + "static/img/ganPic.738dd3a3.png";